import { Dictionary } from '@skylab-shared/types';
import { PropertyMetadata } from './property-metadata';

export interface ModelMetadataProvider {
    identityPropertyMetadata: PropertyMetadata | null;
    properties: PropertyMetadata[];

    getPropertyMetadata(propertyName: string): PropertyMetadata | null;
}

export class ModelMetadataContainer implements ModelMetadataProvider {
    private readonly propertiesMetadata: Dictionary<PropertyMetadata>;

    public constructor() {
        this.propertiesMetadata = {};
    }

    public get properties(): PropertyMetadata[] {
        return Object.keys(this.propertiesMetadata).map(k => this.propertiesMetadata[k]);
    }

    public getPropertyMetadata(propertyName: string): PropertyMetadata | null {
        return this.propertiesMetadata[propertyName] || null;
    }

    public setPropertyMetadata(propertyName: string, metadata: PropertyMetadata): void {
        this.propertiesMetadata[propertyName] = metadata;
    }

    public get identityPropertyMetadata(): PropertyMetadata | null {
        const identityPropertyName = Object.keys(this.propertiesMetadata)
            .find(propertyName => !!this.propertiesMetadata[propertyName].config.identifiable);
        return identityPropertyName ? this.getPropertyMetadata(identityPropertyName) : null;
    }
}
